import { AHEmptyScreen, Box } from "arkh";
import React from "react";
import { Image } from "expo-image";
import { FormattedMessage } from "react-intl";

export function SignalsEmptyScreen() {
  return (
    <AHEmptyScreen
      title={
        <FormattedMessage
          defaultMessage="No signals yet, hang in there!"
          description="Signals empty screen title"
        />
      }
      subtitle={
        <FormattedMessage
          defaultMessage="When there's a signal to see, it will appear here!"
          description="Signals empty screen subtitle"
        />
      }
      illustration={
        <Box style={{ flex: 1 }}>
          <Image
            contentFit="contain"
            style={{ flex: 1 }}
            source={require("./signals_empty.png")}
          />
        </Box>
      }
    />
  );
}
